module.exports = __webpack_public_path__ + "static/media/bulk_upload_ao_paln.58ee8bba.csv";